import { configurePersist } from "zustand-persist";

export const { persist, purge } = configurePersist({
    storage: localStorage, // use `AsyncStorage` in react native
    rootKey: 'root', // optional, default value is `root`
})

